// src/index.js — React-Einstieg: bindet Router & Tailwind-CSS ein

import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
// import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import { store } from "./store";
import App from "./App";
import "./index.css";
import "./styles/admin-coreui.css";
import "./styles/design-governance-foundation.css";
import { debugLog, setDebugMode, clearDebugMode } from "./utils/debuglog";
import "@coreui/coreui-pro/dist/css/coreui.min.css";

// const root = ReactDOM.createRoot(document.getElementById("root"));
const container = document.getElementById("root");
window.debuglog = { debugLog, setDebugMode, clearDebugMode };
axios.defaults.withCredentials = true;

if (typeof window !== "undefined" && typeof window.fetch === "function" && !window.__e4eFetchWithCredentialsPatched) {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) =>
    nativeFetch(input, {
      ...init,
      credentials: init.credentials || "include",
    });
  window.__e4eFetchWithCredentialsPatched = true;
}

const pathname =
  typeof window !== "undefined" && window.location && window.location.pathname
    ? window.location.pathname
    : "/";

const PRERENDERED_ROUTES = new Set([
  "/",
  "/404.html",
  "/menue/tools",
  "/menue/quali",
  "/menue/success",
  "/menue/support",
  "/stb/job-marketplace",
  "/impressum",
  "/agb",
  "/datenschutz",
]);

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

const shouldHydrate = container.hasChildNodes() && PRERENDERED_ROUTES.has(pathname);

if (shouldHydrate) {
  hydrateRoot(container, app);
} else {
  if (container) {
    container.innerHTML = "";
  }
  createRoot(container).render(app);
}
